"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const store_1 = require("../../context/store");
const SlideDrawer_1 = __importDefault(require("../SlideDrawer"));
const Loader_1 = __importDefault(require("../Loader"));
const AddressInput_1 = __importDefault(require("../AddressInput"));
const Unsupported_1 = __importDefault(require("./Unsupported"));
const AltPurchaseOptions_1 = __importDefault(require("./AltPurchaseOptions"));
const ProviderQuote_1 = __importDefault(require("./Provider/ProviderQuote"));
const actions_1 = require("../../context/actions");
const providers_1 = require("../../api/providers");
const useQuotesBuy_1 = __importDefault(require("../../hooks/useQuotesBuy"));
const useWidgetCallback_1 = require("../../hooks/useWidgetCallback");
const styled_1 = require("./styled");
const constants_1 = require("../../data/constants");
const constants_2 = require("../../../BuyWidget/constants");
const ProviderSelect = ({ open, setOpen }) => {
    const { selectedCrypto: { code }, autoSelectProvider, address, passThroughAddress, } = (0, store_1.useTrackedState)();
    const { formatMessage } = (0, react_intl_1.useIntl)();
    const dispatch = (0, store_1.useDispatch)();
    const { loading, quotes, loadingStage } = (0, useQuotesBuy_1.default)(open);
    const [addressOpen, setAddressOpen] = (0, react_1.useState)(false);
    const [hasPassthrough, setHasPassthrough] = (0, react_1.useState)(true);
    const callback = (0, useWidgetCallback_1.useWidgetCallback)();
    const handleClose = (0, react_1.useCallback)(() => {
        if (loading)
            return;
        setOpen(false);
    }, [loading, setOpen]);
    const selectQuote = (0, react_1.useCallback)((quote) => {
        var _a;
        const bestQuote = quote !== null && quote !== void 0 ? quote : quotes[0];
        if (passThroughAddress) {
            callback({
                provider: bestQuote.provider,
                data: {
                    amount: (_a = bestQuote.fiatAmount) === null || _a === void 0 ? void 0 : _a.toString(),
                    fiat: bestQuote.fiatCode,
                    crypto: code,
                    address,
                },
            });
            return;
        }
        dispatch({
            type: actions_1.CONTEXT_ACTIONS.SET_PROVIDER,
            payload: bestQuote.provider,
        });
        dispatch({
            type: actions_1.CONTEXT_ACTIONS.SET_FIAT_VALUE,
            payload: bestQuote.fiatAmount || constants_1.DEFAULT_FIAT_AMOUNT,
        });
        dispatch({
            type: actions_1.CONTEXT_ACTIONS.SET_SELECTED_FIAT,
            payload: bestQuote.fiatCode || constants_2.DEFAULT_FIAT.code,
        });
        setHasPassthrough(providers_1.buyProviders[bestQuote.provider].addressPassthrough);
        setAddressOpen(true);
    }, [dispatch, quotes, passThroughAddress, callback, code, address]);
    (0, react_1.useEffect)(() => {
        if (loading || !autoSelectProvider || !quotes[0])
            return;
        selectQuote();
    }, [autoSelectProvider, loading, quotes, selectQuote]);
    return (react_1.default.createElement(SlideDrawer_1.default, { title: !loading && quotes.length === 0
            ? ""
            : formatMessage({ id: "buy.partner-title" }), show: open, closeFn: handleClose, hideClose: loading },
        react_1.default.createElement(styled_1.ProvidersWrapper, null,
            loading && react_1.default.createElement(Loader_1.default, { buy: true, code: code, stage: loadingStage }),
            !loading && (react_1.default.createElement(react_1.default.Fragment, null,
                !autoSelectProvider && quotes.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(styled_1.PartnerText, null,
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "buy.partner-description" })),
                    quotes.map((q, index) => (react_1.default.createElement(styled_1.Wrapper, { recommended: index === 0, key: q.provider },
                        index === 0 && (react_1.default.createElement(styled_1.RecommendedText, null,
                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "buy.partner-recommended", values: {
                                    best: (react_1.default.createElement("span", { style: { fontWeight: "400" } },
                                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "buy.partner-recommended-best" }))),
                                } }))),
                        react_1.default.createElement(ProviderQuote_1.default, { buy: true, key: q.provider, quote: q, provider: providers_1.buyProviders[q.provider], code: code, callback: () => selectQuote(q) })))))),
                quotes.length === 0 && react_1.default.createElement(Unsupported_1.default, { handleClose: handleClose }),
                !autoSelectProvider && quotes.length > 0 && react_1.default.createElement(AltPurchaseOptions_1.default, null)))),
        react_1.default.createElement(AddressInput_1.default, { open: addressOpen, setOpen: (o) => {
                setAddressOpen(o);
                if (autoSelectProvider) {
                    setOpen(o);
                }
            }, hasPassthrough: hasPassthrough })));
};
exports.default = ProviderSelect;
//# sourceMappingURL=ProviderSelect.js.map